module.exports = __webpack_public_path__ + "img/paypal-payment.0b2fc85b.png";